import { useEffect } from 'react';
import { cleanHttpRefererFromStorage } from './TrackingProvider';
import { useTrackEvent } from './useTrackEvent';
import { EventName } from './events';
import { useAvroTracking } from './avro';

export function TrackRouting() {
  const trackEvent = useTrackEvent();
  const { emitPageViewEvent } = useAvroTracking();

  useEffect(() => {
    cleanHttpRefererFromStorage();

    const trackPageView = () => {
      // setTimeout for reasons of:
      // A) Give added time / tick for identity Cookie to be set (additional safety measure)
      // B) timneutkens does it in next-plugin-google-analytics for equivalent handler https://github.com/vercel/next.js/blob/5fff814ca1e7f78b50535a55d6f99bd842c4e049/packages/next-plugin-google-analytics/src/on-init-client.js
      setTimeout(() => {
        trackEvent(EventName.NAVIGATE, {});
        trackEvent(EventName.PERFORMANCE_MOUNT, {
          timeToMount: window.performance.now(),
          timeToMountType: 'page-ready',
        });

        // Avro page view
        emitPageViewEvent();
      }, 0);
    };

    trackPageView();

    return () => {
      cleanHttpRefererFromStorage();
    };
  }, [emitPageViewEvent, trackEvent]);

  return null;
}
